import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { PlayerBadge, NotificationsContainer, NotificationsIcon } from '@myplay/ui';

import { toTitleCase } from '../../utils/stringManipulations';
import { Settings } from '..';
import logo from '../../assets/icons/header-logo.svg'
import arrow from '../../assets/icons/arrow-white.png';
import I18N from '../../I18N'
import { MYPLAY_APP_ROUTE } from '../../utils/constants';
import "./Header.scss";

const Header = ({ UserStore, VideosStore, NotificationsStore }) => {
  const { data: { avatar, firstName, lastName, avatarBgColor } } = UserStore;
  const { unreadCount, activeTasks, clientUploadTasks } = NotificationsStore;
  const { uploadPercent } = VideosStore;
  const [shouldDisplaySettings, setSettingsFlag] = useState(false);
  const [shouldDisplayNotifications, setNotificationsFlag] = useState(false);

  useEffect(()=> {
    NotificationsStore.getActiveTasksRecursive();
  }, []);

  const handleClick = () => {
    setSettingsFlag(flag => !flag)
  };

  const goToApp = () => {
    const route = `${MYPLAY_APP_ROUTE}/team-channel`;
    window.open(route, '_blank');
  }

  const toggleNotifications = () => {
    setNotificationsFlag(!shouldDisplayNotifications);
  }

  const handleNotificationClick = notification => {
    const { action } = notification;
    let route = "";
    switch (action.type) {
      case "new_video":
      case "upload":
        route = `${MYPLAY_APP_ROUTE}/${action.path}`;
        window.open(route, '_blank');
        break;
      case "clip":
        route = `${MYPLAY_APP_ROUTE}/${action.path.split('/app/')[1]}`;
        window.open(route, '_blank');
        break;
      case "download":
      case "assign":
        window.location.assign(action.link);
        break;
    }
  };

  const activeTasksCount = activeTasks ? activeTasks.length : 0;
  const clientUploadTasksCount = clientUploadTasks ? clientUploadTasks.length : 0;
  const totalCount = activeTasksCount + clientUploadTasksCount;
  
  return (
    <div className="header" data-testid="header">
      <div className="header__logo">
        <img src={logo} alt="" />
      </div>
      <div className="header__upload-indicator" style={{ opacity: uploadPercent ? 1 : 0 }}>
        <div className="header__upload-indicator__dot" />
        <span>{toTitleCase(I18N.t("UPLOADING"))}</span>
        <span style={{ paddingLeft: "5px" }}>{uploadPercent}%</span>
      </div>
      <div className="header__settings-box">
        <button type="button" onClick={goToApp}>
          <span className="header__settings-box__text">{toTitleCase(I18N.t("GO_TO_MYPLAY"))}</span>
        </button>
        {UserStore.data._id &&
          <NotificationsContainer
            NotificationsStore={NotificationsStore}
            isVisible={shouldDisplayNotifications}
            onClickOutside={toggleNotifications}
            onNotificationClick={handleNotificationClick}
          />
        }
        <NotificationsIcon
          unreadCount={unreadCount}
          activeTasksCount={totalCount}
          onClick={toggleNotifications}
        />
        {avatar ?
          <img className="header__settings-box__badge" src={avatar} alt="" /> :
          <PlayerBadge firstName={firstName} lastName={lastName} color={avatarBgColor} fontSize="16" />
        }
        <button onClick={handleClick}>
          <img className="header__settings-box__arrow" src={arrow} alt="" />
        </button>
      </div>
      <Settings isVisible={shouldDisplaySettings} closeMenu={() => setSettingsFlag(false)} />
    </div>
  );
};

Header.propTypes = {
  UserStore: PropTypes.object
};

Header.defaultProps = {
  UserStore: {}
};

export default inject("UserStore", "VideosStore", "NotificationsStore")(observer(Header));